import { devtools } from 'zustand/middleware';

import { type ResourceId } from '@app/client';
import { type SubmissionState } from '@app/client/common/structs';
import { create } from '@app/store/zustand/helpers/create';

interface FantasySubmissionState {
    // new submissions
    newSubmission: boolean;
    showSubmitModal: boolean;
    showSubmitSuccessModal: boolean;
    newSubmissionListId?: ResourceId;
    submissionState: SubmissionState | undefined;
    updateSubmission: (updatedSubmissionState: SubmissionState, id: ResourceId, isNew?: boolean) => void;
    setShowSubmitModal: (showSubmitModal: boolean) => void;
    setShowSubmitSuccessModal: (showSubmitSuccessModal: boolean) => void;
    clearNewSubmission: () => void;
    resetGameSubmissionState: () => void;
}

const initialState = {
    newSubmission: false,
    showSubmitModal: false,
    showSubmitSuccessModal: false,
    newSubmissionListId: undefined,
    submissionState: undefined,
};

export const useFantasySubmissionStore = create<FantasySubmissionState>()(
    devtools(
        (set) => ({
            ...initialState,
            updateSubmission: (updatedSubmissionState, id, isNew = true) =>
                set(() => ({
                    submissionState: updatedSubmissionState,
                    newSubmissionListId: id,
                    newSubmission: isNew,
                })),
            setShowSubmitSuccessModal: (showSubmitSuccessModal) => set({ showSubmitSuccessModal }),
            setShowSubmitModal: (showSubmitModal) => set({ showSubmitModal }),
            clearNewSubmission: () => set({ newSubmission: false }),
            resetGameSubmissionState: () => set(initialState),
        }),
        { name: 'fantasy-submission-status-storage' },
    ),
);
